module.exports = __webpack_public_path__ + "img/fig12.dda41441.jpg";